import React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@material-ui/core';
import amberTheme from 'styles/themes/amberTheme';

const useStyles = makeStyles(
  () =>
    createStyles({
      root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      svg: ({ size }) => ({
        width: size,
        height: size,
        overflow: 'visible',
      }),
      circle: {
        fill: 'none',
        strokeLinecap: 'round',
        strokeDasharray: 166,
        strokeDashoffset: 166,
        animationName: '$drawCircle',
        animationDuration: '0.6s',
        animationTimingFunction: 'ease-in-out',
        animationFillMode: 'forwards',
      },
      check: {
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeDasharray: 48,
        strokeDashoffset: 48,
        animationName: '$drawCheck',
        animationDuration: '0.3s',
        animationTimingFunction: 'ease-in-out',
        animationFillMode: 'forwards',
        animationDelay: '0.35s',
      },
      '@keyframes drawCircle': {
        '0%': {
          strokeDashoffset: 166,
          transform: 'scale(0.9)',
          opacity: 0,
        },
        '70%': {
          transform: 'scale(1.04)',
          opacity: 1,
        },
        '100%': {
          strokeDashoffset: 0,
          transform: 'scale(1)',
          opacity: 1,
        },
      },
      '@keyframes drawCheck': {
        '0%': {
          strokeDashoffset: 48,
        },
        '100%': {
          strokeDashoffset: 0,
        },
      },
    }),
  { name: 'AnimatedCheckmark' }
);

export const AnimatedCheckmark = ({
  size = 64,
  strokeWidth = 4,
  checkWidth = 4,
  circleColor = amberTheme.palette.status.success,
  checkColor = amberTheme.palette.status.success,
  className,
  ...rest
}) => {
  const classes = useStyles({ size });

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <svg className={classes.svg} viewBox="0 0 60 60" role="img" aria-label="success">
        <circle
          className={classes.circle}
          cx="30"
          cy="30"
          r="25"
          stroke={circleColor}
          strokeWidth={strokeWidth}
        />
        <polyline
          className={classes.check}
          points="18 31 27 40 42 22"
          stroke={checkColor}
          strokeWidth={checkWidth}
        />
      </svg>
    </div>
  );
};
